import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { checkIfEmpty, dateTimeToString } from "components/Shared/Formatters";
import { cloneDeep, isEqual } from "lodash";
import { MCollapsibleCard } from "components/Shared";

function getStatus(status) {
  const statuses = {
    0: "Not available for this appraisal.",
    1: "Request has not been submitted yet.",
    2: "Changes have occurred since the last request.",
    3: "Pending result.  Please wait.",
    4: "Request completed ",
  };
  return statuses[status];
}

class IssuesList extends Component {
  constructor(props) {
    super(props);
    this.allowOverrideComment = this.allowOverrideComment.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.openCard = this.openCard.bind(this);
    this.state = {
      items: [],
      invalid: false,
      pristine: true,
      submitting: false,
      collapsed: true
    };

    this.ref = React.createRef();
  }

  UNSAFE_componentWillMount () {
    let items = cloneDeep(this.props.items);
    // initialize the editable setting (Override comments required on certain options)
    let needsResolveDate = false;
    items.forEach((item) => {
      item.editable = this.allowOverrideComment(item);
      needsResolveDate |= (item.selectedVerosOverrideTypeId && !item.resolvedDate);
    });

    if (needsResolveDate) {
      this.setState({items: items, pristine: false });
    } else {
      this.setState({items: items});
    }

    if (this.props.getControlMethods) {
      this.props.getControlMethods({ ref: this.ref, openCard: this.openCard });
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.items) {
      const itemsChanged = !isEqual(nextProps.items, this.props.items);
      if (itemsChanged) {
        let items = cloneDeep(nextProps.items);
        // initialize the editable setting (Override comments required on certain options)
        let needsResolveDate = false;
        items.forEach((item) => {
          item.editable = this.allowOverrideComment(item);
          needsResolveDate |= (item.selectedVerosOverrideTypeId && !item.resolvedDate);
        });
    
        if (needsResolveDate) {
          this.setState({items: items, pristine: false });
        } else {
          this.setState({items: items});
        }
      }
    }
  }

  allowOverrideComment(item) {
    let editable = false;
    if (item && item.choices.length > 0) {
      item.choices.forEach((c) => {
        if (c.id === item.selectedVerosOverrideTypeId) {
          editable = c.commentRequired === true;
        }
      });
    }
    return editable;
  }

  onSubmit(e) {
    e.preventDefault();
    const items = this.state.items;
    this.setState({submitting: true});
    if (!this.state.invalid) {
      // do it
      this.props.handleSubmit(items);
    } else {
      // toast it up
    }
    this.setState({submitting: false, pristine: true});
  }

  toggle() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  openCard() {
    this.setState({ collapsed: false });
  }

  changedOverrideType(rowId, val) {
    setTimeout(() => {
      const items = this.state.items;
      let currentItem = null;
      let currentChoice = null;
      items.forEach((item) => {
        if (item.id === rowId) {
          currentItem = item;
        }
      });
      if (currentItem != null) {
        currentItem.choices.forEach((c) => {
          if (c.id === val) {
            currentChoice = c;
          }
        });
      }
      if (currentItem.selectedVerosOverrideTypeId !== currentChoice.id) {
        currentItem.editable = (currentChoice.commentRequired === true);
        currentItem.selectedVerosOverrideTypeId = currentChoice.id;
        this.setState({items: items, pristine: false });
      }
    }, 500);
  }

  changedOverrideComment(rowId, val) {
    setTimeout(() => {
      const items = this.state.items;
      let currentItem = null;
      items.forEach((item) => {
        if (item.id === rowId) {
          currentItem = item;
        }
      });
      if (currentItem.selectedOverrideComment !== val) {
        currentItem.selectedOverrideComment = val;
        this.setState({items: items, pristine: false });
      }
    }, 500);
  }
  
  buildMenu(choiceList) {
    let menuItems = [];
    choiceList.map((c) => {
      menuItems.push({
        key: c.id,
        label: c.name,
        value: c.id
      });
    });
    return menuItems;
  }

  getChoice(choices, id, severity) {
    if (choices.length === 0) {
      if(severity !== "Hard Stop") {
        return <span className="veros-no-override-message">Override automatically approved.</span>;
      } else {
        return <span className="veros-no-override-message">Override or fix may be required.</span>;        
      }
    }
    if (choices.length === 1) {
      return choices[0];
    }
    return choices.find((item) => {
      return item.id === id;
    });
  }

  
  render() {
    const { readOnly, status, date, title } = this.props;
    const { invalid, pristine, submitting, items } = this.state;

    return (
      <div ref={this.ref}>
        <MCollapsibleCard
          title={title}
          expanded={!this.state.collapsed}
          onExpandedChange={(expanded) => this.setState({ collapsed: !expanded })}
          styledHeader={false}
        >
          {items.length
          ? 
            <div className="veros-override-grid md-cell--12 md-grid md-grid--no-spacing">
              <div className="veros-status md-cell--6"> {getStatus(status)} </div>
              <div className="veros-date md-cell--6 text-right"> {date}  </div>
              <TableContainer component="div" className="md-cell--12">
                <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ maxWidth: 60 }}>Code</TableCell>
                    <TableCell style={{ width: "20%", minWidth: 200 }}>Action Message</TableCell>
                    <TableCell>Form Section</TableCell>
                    <TableCell style={{width: "20%"}}>Form Field</TableCell>
                    <TableCell>Property Affected</TableCell>
                    <TableCell style={{ width: "20%", minWidth: 250, maxWidth: 600}}>Override Request</TableCell>
                    <TableCell style={{ width: "20%", minWidth: 300 }}>Override Comment</TableCell>
                    <TableCell style={{ maxWidth: 100 }}>Override Date</TableCell>
                    <TableCell>Severity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map(({ id, resultCode, resultMessage, formSection, formField, propertyAffected, severity,
                        selectedVerosOverrideTypeId, selectedOverrideComment, resolvedDate, choices, editable }) => (
                    <TableRow key={id}>
                      <TableCell>{resultCode}</TableCell>
                      <TableCell>{resultMessage}</TableCell>
                      <TableCell>{checkIfEmpty(formSection, "N/A", "veros-no-override-message")}</TableCell>
                      <TableCell>{checkIfEmpty(formField, "N/A", "veros-no-override-message")}</TableCell>
                      <TableCell>{checkIfEmpty(propertyAffected, "N/A", "veros-no-override-message")}</TableCell>
                      {readOnly || choices.length < 2 
                        ? <TableCell>{this.getChoice(choices, selectedVerosOverrideTypeId, severity)}</TableCell>
                        : <TableCell>
                            <TextField
                              select
                              size="small"
                              defaultValue={selectedVerosOverrideTypeId}
                              onChange={(e) => this.changedOverrideType(id, e.target.value)}
                              fullWidth
                            >
                              {this.buildMenu(choices).map((item) => (
                                <MenuItem key={item.key} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              ))}
                            </TextField>
                          </TableCell>
                      }
                      {readOnly || choices.length < 2
                        ? <TableCell><span className="veros-no-override-message">No override comment.</span></TableCell>
                        : <TableCell>
                            <TextField
                              size="small"
                              defaultValue={selectedOverrideComment || ""}
                              onChange={(e) => this.changedOverrideComment(id, e.target.value)}
                              disabled={readOnly || !editable}
                              fullWidth
                            />
                          </TableCell>
                      }
                      <TableCell>{dateTimeToString(resolvedDate)}</TableCell>
                      <TableCell>{checkIfEmpty(severity, "N/A", "veros-no-override-message")}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                </Table>
              </TableContainer>
              <div className="md-cell--12">
                <br />
                <Button
                  type="submit"
                  disabled={readOnly || invalid || pristine || submitting}
                  onClick={this.onSubmit}
                >
                  Save Overrides
                </Button>
              </div>
            </div>
          :
            <div className="md-cell--12 veros-no-errors">{getStatus(status)}</div>
          }
        </MCollapsibleCard>
      </div>      
    );
  }
}
IssuesList.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  status: PropTypes.number.isRequired,
  readOnly: PropTypes.bool.isRequired,
  items: PropTypes.array,
  handleSubmit: PropTypes.func.isRequired,
  getControlMethods: PropTypes.func,
};

export { getStatus, IssuesList };